import { EnvironmentProviders, inject, Injector, provideAppInitializer, Provider } from '@angular/core';

import { AUTH_GUARD_CONFIG, RedirectCommandProvider } from '@guardfinder/shared';

import { AuthGuardConfigProviderService } from './auth-guard-config-provider.service';

/**
 * Provides the default configuration for the AuthGuard.
 *
 * This configuration fetches the `defaultPath` from the `RedirectCommandProvider` using the `APP_INIT` redirect strategy.
 * By setting `isClientLoggedIn` to `false`, it ensures the user is redirected to a default route (e.g., the welcome screen)
 * when not authenticated. This approach centralizes redirect logic, creating a single entry point for app navigation defaults.
 * @See AuthGuard
 */
export function provideAuthGuardConfig(): Provider | EnvironmentProviders[] {
    return [
        provideAppInitializer(async () => {
            const authGuardConfigProvider = inject(AuthGuardConfigProviderService);
            const redirectCommandProvider = inject(RedirectCommandProvider);
            return authGuardConfigProvider.loadConfig(redirectCommandProvider);
        }),
        {
            provide: AUTH_GUARD_CONFIG,
            useFactory: () => {
                const authGuardConfigProvider = inject(AuthGuardConfigProviderService);
                return authGuardConfigProvider.getConfig();
            },
            deps: [Injector]
        }
    ];
}
